<template lang="pug">
  v-container(fluid class="pa-0")
    v-row(justify="start" wrap)
      v-col(cols="4", v-for="item in complexList", :key="item.complexId")
        ComplexCard(:complex="item" @view-complex="viewComplexPage")
</template>

<script>
import ComplexCard from '../../components/Complex/ComplexCard'
export default {
  name: 'ComplexList',
  components: { ComplexCard },
  created() {
    this.$store.dispatch('GET_ALL_COMPLEX_LIST')
  },
  computed: {
    complexList() {
      return this.$store.state.complex.complexAllList
    }
  },
  methods: {
    viewComplexPage(id) {
      this.$store.dispatch('SET_VIEWED_COMPLEX', id)
      this.$router.push({ path: `/complex/${id}` })
    }
  }
}
</script>
<style lang="scss" scoped></style>
